export default __webpack_public_path__ + "static/media/wetu.e927e31f.svg";